import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { Acc_Txn_Service } from '../../../services/Acc_Txn_Servcies';
import { Global } from '../../global';
import { UtilityService } from '../../../services/Acc_Utility.service';
import { GL_MasterService } from '../../../services/Acc_GL_Master.service';
import { JournalEntry } from '../../../models/Txn_JournalEntry';
import {MatSnackBar} from '@angular/material';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import * as moment from 'jalali-moment';
import { DatePipe } from '@angular/common';
import { AccountMappingService } from '../../../services/AccountMappingService';
import { map, startWith } from 'rxjs/operators';
import * as $ from 'jquery';
import {FormControl,FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-fix-assets',
  templateUrl: './fix-assets.component.html',
  styleUrls: ['./fix-assets.component.css']
})
export class FixAssetsComponent implements OnInit {

  ArrLabels: any;
  labels: any = {};

  FixAssetAccounts: any;

  txns: JournalEntry[];

  ArrAccountMaps: any;
  fixedAccountMaster: string;
  fixedAssetAccounts: any;
  CreditAccount: string;
  // response objects
  txn_result: any;
  arr_results: any = {};
  filteredOptions: Observable<string[]>;
  myControl = new FormControl();

  txn_DR: JournalEntry = {
    module: "FT",
    trn_ref_no: "",
    event_sr_no:1,
    eventName:"INIT",
    ac_entry_sr_no: 0,
    ac_branch: "000",
    GL_Code :"",
    drcr_ind: "DR",
    trn_code:"FIX",
    trn_amount: null,
    trn_date:new Date(),
    value_date: new Date(),
    financial_cycle:"2018",
    period_code:"M4",
    batch_no:"1111",
    MakerID:"test",
    CheckerID :"test",
    auth_stat:"A",
    delete_stat:"",
    product:"FIXI",
    external_ref_no :"ext",
    entry_seq_no : 0,
    remarks: "",
    userId: "",
    documentNo: "",
    branchId: 0,
    statusId: 0,
    isPrint: false,
    branchTitle: '',
    statusTitle: '',
    }

    txn_CR: JournalEntry = {
      module: "FT",
      trn_ref_no: "",
      event_sr_no:2,
      eventName:"INIT",
      ac_entry_sr_no: 0,
      ac_branch: "000",
      GL_Code :"",
      drcr_ind: "CR",
      trn_code:"FIX",
      trn_amount: null,
      trn_date:new Date(),
      value_date: new Date(),
      financial_cycle:"",
      period_code:"",
      batch_no:"",
      MakerID:"",
      CheckerID :"",
      auth_stat:"",
      delete_stat:"",
      product:"FIXI",
      external_ref_no :"",
      entry_seq_no : 0,
      remarks: "",
      userId: "",
      documentNo: "",
      branchId: 0,
      statusId: 0,
      isPrint: false,
      branchTitle: '',
      statusTitle:'',
      }

      selectedFixAssetName: any;
     pdate = moment(new Date()).format('jYYYY-jMM-jDD');    // Dari date

  constructor(
    private GL_MasterService: GL_MasterService,
    private global:Global,
    private UtilityService: UtilityService,
    private Txn_DE_Service: Acc_Txn_Service,
    public snackBar: MatSnackBar,
    public datepipe: DatePipe,
    private AccountMapService: AccountMappingService
  ) { }

  resetTrns(){
    this.txn_DR.trn_amount = null;
    this.txn_DR.value_date = new Date();
    this.txn_DR.remarks = '';
    this.txn_DR.GL_Code = '';

    this.txn_CR.trn_amount = null;
    this.txn_CR.value_date = new Date();
    this.txn_CR.remarks = '';
  }

  ngOnInit() {
    this.getLabels();

    this.loadAssets();
    this.getBranchId();
  }

  isBranchId: number = -1;
  userId: string = "";
  getBranchId() {
     
    let data = localStorage.getItem('accessKeyUser');
    let dataAccess = JSON.parse(data);
    let dataAccessUrl = dataAccess.filter(f => f.accessKeyUrl == "/fixAssets")[0];
    if (dataAccessUrl != undefined) {
      if (dataAccessUrl.isMainBranch)
        this.isBranchId = 1;
      else if (dataAccessUrl.isWestBranch)
        this.isBranchId = 2;
      else
        this.isBranchId = 0;
      this.userId = dataAccessUrl.userId;
    }
  }

  loadAssets() {

    let maps$:Observable<Object> = this.AccountMapService.getAccountMapping('fix-assets');
    let gl_childs$:Observable<Object> = maps$.mergeMap(maps => {
      this.ArrAccountMaps = maps;
      this.txn_CR.GL_Code = this.ArrAccountMaps.find( (o:any) => o.component === 'fix-assets' &&  o.drcr === 'C' ).childAcc;
      this.fixedAccountMaster = this.ArrAccountMaps.find( (o:any) => o.component === 'fix-assets' &&  o.drcr === 'D'  && o.trnCode === 'AAT' ).masterAcc;
      return this.GL_MasterService.getNotInitFixAssests(this.fixedAccountMaster);
    })

    gl_childs$.subscribe(FixedAccounts => {
      this.fixedAssetAccounts = FixedAccounts;
       this.filteredOptions = this.myControl.valueChanges
           .pipe(
             startWith(''),
             map(value => this._filter(value))
           )
          })
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.fixedAssetAccounts.filter(option => option.gL_ChildCode.toLowerCase().includes(filterValue));
  }

  submit()
  {
    // submit the asset
    var gdate = new Date(this.datepipe.transform(this.txn_DR.value_date,'yyyy-MM-dd'));
    this.txn_DR.value_date = gdate;
    
    this.txn_CR.trn_amount = this.txn_DR.trn_amount;
    this.txn_CR.value_date = this.txn_DR.value_date;
    this.txn_CR.remarks = this.txn_DR.remarks;
    this.txn_CR.userId = this.userId;
    this.txn_DR.userId = this.userId;

    this.txns = [this.txn_DR,this.txn_CR];
    this.Txn_DE_Service.CreateTxn_DE_Contract(this.txns)
      .subscribe(response => {
        if(response){
           this.txn_result = response;
           this.txn_result = response.json();
           this.arr_results['result'] = this.txn_result.find( (o:any) => o.key === 'result').value;
           this.arr_results['trn_ref_no'] = this.txn_result.find( (o:any) => o.key === 'trn_ref_no').value;
          if (this.arr_results['result'] == 'success')
          {
            this.txn_DR.trn_ref_no = this.arr_results['trn_ref_no'];
            console.log('transaction succeed. trn_ref_no --> ' + this.txn_DR.trn_ref_no);            
            this.resetTrns();
            this.openSnackBar(this.txn_DR.trn_ref_no,'چاپ');
            this.loadAssets();
          }
           
        }
    },
    error => console.log(error));

  }

  trnDateChanged(type: string, event: MatDatepickerInputEvent<Date>) {
    //console.log(`${type}: ${event.value}` );
    this.pdate = moment(event.value).format('jYYYY-jMM-jDD');
    this.txn_DR.value_date = moment(event.value).toDate();
  }

  openSnackBar(message: string, action: string) {
    let snackBarRef = this.snackBar.open(message, action, {
      duration: 5000,
    });
    snackBarRef.closeWithAction = function() {
      print();
      snackBarRef.dismiss();
    }
    // snackBarRef.afterDismissed().subscribe(null, null, () => {
    //   console.log('dismissed');
    // })
  }

  print(): void {
    alert('print');
}

  getLabels(){
    this.UtilityService.getLabels('fix-assets',this.global.lang)
      .subscribe(response => {
          if(response){
              this.ArrLabels = response;
              this.setLabels();
          }
      },
      error => console.log(error))
    }
    FixAssetChanged(event)
    {
      console.log(event.source.triggerValue);
      this.selectedFixAssetName = event.source.triggerValue
    }
  setLabels(){
    //title
    this.labels['fix-assets-Title'] = this.ArrLabels.find( (o:any) => o.key === 'fix-assets-Title').value;

    // labels
    this.labels['FixAssetAccount'] = this.ArrLabels.find( (o:any) => o.key === 'FixAssetAccount').value;
    this.labels['PurchaseDate'] = this.ArrLabels.find( (o:any) => o.key === 'PurchaseDate').value;
    this.labels['PurchaseAmount'] = this.ArrLabels.find( (o:any) => o.key === 'PurchaseAmount').value;
    this.labels['AssetRemarks'] = this.ArrLabels.find( (o:any) => o.key === 'AssetRemarks').value;

    // Alerts
    this.labels['AccountMandatory'] = this.ArrLabels.find( (o:any) => o.key === 'AccountMandatory').value;
    this.labels['AmountMandatory'] = this.ArrLabels.find( (o:any) => o.key === 'AmountMandatory').value;

    // shared labels.
    this.labels['RecordStat'] = this.ArrLabels.find( (o:any) => o.key === 'RecordStat').value;
    this.labels['AuthStat'] = this.ArrLabels.find( (o:any) => o.key === 'AuthStat').value;
    this.labels['CreateDate'] = this.ArrLabels.find( (o:any) => o.key === 'CreateDate').value;
    this.labels['CheckerID'] = this.ArrLabels.find( (o:any) => o.key === 'CheckerID').value;
    this.labels['MakerID'] = this.ArrLabels.find( (o:any) => o.key === 'MakerID').value;

  }



}



// WEBPACK FOOTER //
// ./src/app/components/TRNs/fix-assets/fix-assets.component.ts